export default "__VITE_ASSET__CVeR_lrm__"